<tour-step-template class="tour-step-template">
    <ng-template let-step="step">
        <div
            class="tour-card"
            (click)="onClick($event)"
            [style.width]="step.stepDimensions?.width"
            [style.min-width]="step.stepDimensions?.minWidth"
            [style.max-width]="step.stepDimensions?.maxWidth"
            [style.height]="step.stepDimensions?.height"
            [style.min-height]="step.stepDimensions?.minHeight"
            [style.max-height]="step.stepDimensions?.maxHeight"
        >
            <div class="header">
                <div class="header-group">
                    <div>
                        <h2 class="title font-poppins">{{ step.title }}</h2>
                    </div>
                    <button mat-icon-button (click)="tourEnd()" class="close">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <div class="body-section-container">
                <div class="body" [innerHTML]="step.content"></div>
            </div>

            @if (!isDirectSearchTour) {
            <div class="bottom-section" [class.no-progress]="!step.showProgress">
                <!-- PREV BUTTON -->
                <button
                    mat-stroked-button
                    class="prev"
                    [disabled]="!customTourService.hasPrev(step)"
                    (click)="tourPrev()"
                >
                    <mat-icon>chevron_left</mat-icon>
                    {{ step.prevBtnTitle }}
                </button>

                <!-- PROGRESS -->
                @if (step.showProgress) {
                <div class="progress">
                    {{ customTourService.steps.indexOf(step) + 1 }} / {{ customTourService.steps.length }}
                </div>
                }

                <!-- NEXT BUTTON -->
                @if (customTourService.hasNext(step) && !step.nextOnAnchorClick) {
                <button mat-stroked-button class="next" (click)="tourNext()">
                    {{ step.nextBtnTitle }}
                    <mat-icon>chevron_right</mat-icon>
                </button>
                }

                <!-- END BUTTON -->
                @if (!customTourService.hasNext(step)) {
                <button mat-stroked-button class="end" (click)="tourEnd()">
                    {{ step.endBtnTitle }}
                </button>
                }
            </div>
            }
        </div>
    </ng-template>
</tour-step-template>

<div class="centered-tour-element" tourAnchor="centeredTourStep"></div>
